import React from "react";

import { KeyIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import * as S from "./AdminTag.styles";

const AdminTag = () => {
  const intl = useIntl();
  return (
    <S.AdminTagWrapper variant="gray">
      <KeyIcon /> {intl.formatMessage({ id: "admin_tag" })}
    </S.AdminTagWrapper>
  );
};

export default AdminTag;
